<template>
  <!-- eslint-disable max-len -->
  <div
    class="order-card-header small-padding-right-xxs small-padding-left-xxs small-padding-xs medium-padding-xs medium-padding-right-s medium-padding-left-s grid-x align-justify"
  >
    <div>
      <div v-if="orderDate">
        {{ purchaseLabel }}: <span class="heavy">{{ orderDate }}</span>
      </div>
    </div>
    <!-- eslint-disable vue/no-v-text-v-html-on-component -->
    <div v-if="page === 'orderDetails'" class="order-number" v-text="`${orderText} ${orderNumber}`"></div>
    <div v-else>
      <NuxtLink
        :to="{
          name: 'Order Details',
          params: { orderNumber },
          query: orderToken,
        }"
        class="link-body order-number"
        v-text="`${orderText} ${orderNumber}`"
      />
    </div>
  </div>
</template>

<script setup>
import { ORDER_HISTORY } from 'config';
import { computed } from 'vue';

defineProps({
  orderToken: {
    type: Object,
    required: false,
    default: () => {},
  },
  page: {
    type: String,
    required: false,
    default: '',
  },
  orderNumber: {
    type: String,
    required: true,
  },
  orderDate: {
    type: String,
    required: true,
  },
});

const orderCardHeader = computed(() => ORDER_HISTORY.orderCardHeader || {});
const { orderText, purchaseLabel } = orderCardHeader.value;
</script>

<style lang="scss" scoped>
.order-card-header {
  background-color: $background-color;
  border-top: $gray-1-border;
  @media screen and (max-width: rem-calc(600)) {
    .order-number {
      font-size: rem-calc(12);
    }
  }
}
</style>
